import React from 'react';
import { Path, Svg } from 'react-native-svg';

export interface ChevronDownIconProps {
    size?: number;
    color?: string;
}

export function ChevronDownIcon({ size = 18, color = '#B3B3B3' }: ChevronDownIconProps) {
    return (
        <Svg width={size} height={size} viewBox="0 0 18 18" fill="none">
            <Path
                d="M4.5 6.75L9 11.25L13.5 6.75"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Svg>
    );
}